import { gql } from "@/gql";

export const GET_DISCOUNTS = gql(`
  query GetDiscounts($salonId: ID!) {
    getDiscounts(salonId: $salonId) {
      id
      name
      scope
      couponType
      code
      isActive
      autoApply
      minSpent
      conditions {
        minSpent
        timeCondition {
          activePeriod {
            startDatetime
            endDatetime
          }
          targetedPeriod {
            startDatetime
            endDatetime
            offPeakHours {
              dayOfWeek
              timeRanges
            }
          }
        }
      }
      rules {
        applyTo
        items {
          valueType
          value
          target {
            type
            serviceIds
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`);
